exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip__color[data-v-32350894] {\n  color: #1e9fff;\n  font-size: 18px;\n  font-weight: bold;\n}", ""]);

// exports
